import { RelatedDataView } from '@mark43/cad-api';

export const initialRelatedData: RelatedDataView = {
    cadEvents: [],
    cadEventsCount: 0,
    rmsReports: [],
    rmsReportsCount: 0,
    vehicles: [],
    vehiclesCount: 0,
};
export const DATA_ITEM_LINE_HEIGHT = '16.8px';
